import {FormProvider, useForm} from 'react-hook-form'
import PropTypes from 'prop-types'
import {Link as RouterLink} from 'react-router-dom'

import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'

import Form from '../shared/Form'
import Input from '../shared/Input'
import Email from '../shared/Email'

import './signIn.scss'

const SignIn = ({handleSubmit, loading, error}) => {
  const methods = useForm()
  const {errors} = methods.formState

  return (
    <Paper elevation={3} component='div' className='sign-in'>
      <Typography variant='h5' sx={{color: 'text.primary'}}>Sign In</Typography>
      {error && <Alert severity='error' sx={{marginBottom: '10px'}}>{error}</Alert>}
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit}>
          <Email error={!!errors.email} helperText={errors.email?.message} />
          <Input
            error={!!errors.password}
            label='Password'
            name='password'
            type='password'
            options={{required: 'Password is required'}}
            helperText={errors.password?.message}
            margin='dense'
          />
          <Button
            disabled={loading}
            type='submit'
            variant='contained'
            sx={{color: '#F7F7F7'}}>
            Sign In
          </Button>
        </Form>
      </FormProvider>
      <Link to='/auth/forgot-password' component={RouterLink} color='primary' underline='hover'>
        <Typography variant='body1' color='secondary'>Forgot password?</Typography>
      </Link>
    </Paper>
  )
}

SignIn.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.string,
  handleSubmit: PropTypes.func
}

export default SignIn
